<template>
  <div class="positionAbsolute t0 l0 h100 w100 allowScrollY touch">
    

    <topNavi/>

    <homeMain/>
    <project v-if="isShowProject"/>

  </div>
</template>

<script>
  import i18n from '@/language';
  import { store } from '../store'
  import topNavi from '../components/topNavi.vue';
  import homeMain from '../components/homeMain.vue';
  import project from '../components/project.vue';

  export default {
    name: 'ivan',
    components: {
      topNavi,
      homeMain,
      project,
    },
    data () {
      return {
        isShowProject : false,
      }
    },
    created(){
      
    },

    mounted(){
      //this.showProject();
      document.onreadystatechange = () => { 
        if (document.readyState == "complete") { 
          setTimeout(() => {
            store.state.isLoadingFinished = true;
            this.isShowProject = true;
          }, 1000);
        } 
      }
    },


    methods:{
      showProject(){
        let self = this;
        setTimeout(() => {
          self.isShowProject = true;
        }, 100);
      }
    },

    computed:{
      // checkIsShowLoading(){return store.state.isShowLoading},
      // checkSelectingIndex(){
      //   return store.state.selectingIndex;
      // },
      // checkContactEvent(){return store.state.contactEvent},
    },
    watch:{
      // checkIsShowLoading(flag){
      //   this.isShowLoading = flag
      // },

      // checkSelectingIndex(flag){
      //   //this.autoScroll();
      // },
      // checkContactEvent(flag){
      //   if(flag == true){
      //     store.state.contactEvent = false;
      //     document.getElementById("webpage").scrollTop = 0;
      //   }
      // }
    },


  }
</script>
<style>
  .contentArea{
    margin-top: 5em;
    height: calc(100% - 5em);
  }
</style>



// WEBPACK FOOTER //
// src/pages/ivan.vue